export default {"src":"/_next/static/media/affiliate-program-badge.3982b4df.svg","height":31,"width":246,"blurWidth":0,"blurHeight":0};